module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "Title",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/gettingmost#_idTextAnchor000"
    }
  }, [_vm._v("Getting the Most Out of "), _c('i', [_vm._v("Apostles’ Creed")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor001",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1 I Believe")]), _vm._v("—Genesis 12:1-8; 15:1-6")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor002",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2 God the Father")]), _vm._v("—Isaiah 40:21-31")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor003",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3 God the Son: His Identity and Birth")]), _vm._v("—Philippians 2:5-11")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor004",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4 God the Son: His Death and Resurrection")]), _vm._v("—1 Corinthians 15:1-28")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5 God the Son: His Present Activity and Future Role; God the Holy Spirit")]), _vm._v("—Colossians 1:15-20; 1 Corinthians 12:1-11")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor006",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6 The Church, ­Forgiveness and Eternal Life")]), _vm._v("—Ephesians 4:1-13")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/leadersnotes#_idTextAnchor008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leader’s Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/alsofrom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also from Alister McGrath")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")]), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 60
// module chunks = 0